import UIHelper from 'helpers/UIHelper';

const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

const fileField = (file) => {
  const url = file?.url;
  const name = file?.file_name;
  if (!url) {
    return '—';
  }
  return (
    <a href={url} target='_blank' rel='noreferrer'>
      {name || url}
    </a>
  );
};

export const getAcademyArticleViewSections = (t, item) => {
  if (!item?.id) {
    return [];
  }

  return [
    {
      title: t('Informazioni Generali'),
      fields: [
        { text: t('Titolo'), value: display(item.title) },
        {
          text: t('Outlet Village'),
          value: display(item.shopping_center?.title),
        },
        {
          text: t('Modulo'),
          value: display(item.academy_category?.title),
        },
        {
          text: t('Data Pubblicazione'),
          value: item.date ? UIHelper.formatedDate(item.date) : '—',
        },
        { text: t('Macro-Area'), value: display(item.macro_area) },
        {
          text: t('Pubblica su telegram'),
          value: item.in_telegram ? t('Yes') : t('No'),
        },
        { text: t('Contenuto'), value: display(item.type_file) },
        { text: t('Allegato'), value: fileField(item.file) },
        {
          text: t('Visualizzazioni'),
          value: display(item.count_show ?? 0),
        },
      ],
    },
  ];
};
